import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import { API_URLS } from '../constants/apiUrl';
import { useLoading } from '../context/LoadingContext';
import { post } from '../api/api';
import { showToast } from '../components/utils/toast';
import { IFavorite } from '../interface/favorite';
type CreateFavoriteWithParams = {
  companyId?: string;
  privatePersonId?: string;
  matterId?: string;
  transactionId?: string;
  successMessage: string;
  params?: Record<string, string>;
};
const createFavorite = async ({
  companyId,
  privatePersonId,
  matterId,
  transactionId,
}: CreateFavoriteWithParams): Promise<IFavorite> => {
  return post(API_URLS.FAVORITE, { companyId, privatePersonId, matterId, transactionId });
};

export const useCreateFavorite = (): UseMutationResult<
  IFavorite,
  AxiosError<{ message?: string; type?: string }>,
  CreateFavoriteWithParams
> => {
  const { setIsLoading } = useLoading();

  return useMutation({
    mutationFn: createFavorite,
    onMutate: () => {
      setIsLoading(true);
    },
    onSuccess: (_data, variables) => {
      showToast('success', variables.successMessage);
    },
    onError: (error) => {
      showToast('error', error.message);
    },
    onSettled: () => {
      setIsLoading(false);
    },
  });
};
